import React from "react";
import { IconProps } from "..";

export default (props: IconProps) => (
    <svg {...props} width="14" height="14" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M8.773 12.833a.392.392 0 0 1-.391-.391v-3.34h-2.93v3.34a.392.392 0 0 1-.392.391H2.142a.392.392 0 0 1-.392-.391V5.714c0-.113.05-.221.134-.295L6.66 1.263a.392.392 0 0 1 .515 0l4.774 4.156a.392.392 0 0 1 .135.295v6.728a.392.392 0 0 1-.392.391H8.773z"
            fill="#706F6F"
            fillRule="evenodd"
        />
    </svg>
);
